<template>
  <div>
    <v-btn text :small='small' v-show='hideCancel === false' @click='cancel' class='mr-1' :color='cancelColor'>{{ cancelText }}</v-btn>
    <v-btn depressed :small='small' v-show='hideSave === false' :loading='loading' :disabled='disabled' @click='save' :color='saveColor'>{{ saveText }}</v-btn>
  </div>
</template>

<script>
export default {
  name: 'save-cancel-buttons',
  props: {
    cancelText: {
      required: false,
      default: 'Cancel'
    },
    saveText: {
      required: false,
      default: 'Save'
    },
    small: {
      required: false,
      default: true
    },
    saveColor: {
      required: false,
      default: 'primary'
    },
    cancelColor: {
      required: false,
      default: ''
    },
    disabled: {
      required: false,
      default: false
    },
    loading: {
      required: false,
      default: false
    },
    hideCancel: {
      required: false,
      type: Boolean,
      default: false
    },
    hideSave: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    save () {
      this.$emit('save')
    }
  }
}
</script>
